import styled from "@emotion/styled"
import { breakpoint } from "@porsche-design-system/components-react/emotion"
import { mainNavigationHeightDesktop, mainNavigationHeightMobile } from "./mainNavigation/mainNavigationHeight.const"

export const Main = styled.main`
	display: flex;
	flex-direction: column;
	min-height: calc(100vh - ${mainNavigationHeightMobile});

	@media (min-width: ${breakpoint.m}px) {
		min-height: calc(100vh - ${mainNavigationHeightDesktop});
	}
	
	> * {
		width: 100%;
	}
`
